import useIsDesktop from '../hooks/useIsDesktop';
import './LandingDesktopQR.scss';

export default function LandingDesktopQR({ qrImageSrc }) {
  const isDesktop = useIsDesktop();
  
  if (!isDesktop) {
    return null;
  }

  return (
    <div className="landing-desktop-qr">
        <div className="landing-desktop-qr__logo">
          <img src="/images/logo.svg" alt="Joby" />
        </div>
      {/*
      <div className="landing-desktop-qr__qr-container">
        <div className="landing-desktop-qr__qr">
          <img 
            src={qrImageSrc} 
            alt="QR Code" 
            className="landing-desktop-qr__qr-image"
          />
        </div>
      </div>
      */}
      <div className="landing-desktop-qr__content">
        <h2 className="landing-desktop-qr__title">
          {/* Scan the QR. <br />*/}
          The city looks different<br />from up here.
        </h2>
        <p className="landing-desktop-qr__description">
            Rise above traffic and experience an AR journey into the future of urban travel.<br/>
            Faster, calmer, and completely reimagined.
        </p>
      </div>
    </div>
  );
}

